import React, { useEffect, useState } from "react";
import Chatbox from "./Chatbox";
import "../../../style/chai.css";

function Chai({ startChai, advice }) {
  const [messages, setMessages] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [btnIsDisabled, setBtnIsDisabled] = useState(true);

  const updateLastMessage = (streamData, lastMessage) => {
    const updatedLastMessage = {...lastMessage}
    const isStreaming = lastMessage.text !== "..."
    if(streamData.type=="conversation") {
      setConversationId(streamData.value.id)
    }
    if(streamData.type ==="streaming" && isStreaming) {
      updatedLastMessage.text+=streamData.value
    }
    if(streamData.type ==="streaming" && !isStreaming && streamData.value.length) {
      updatedLastMessage.text = streamData.value
    }
    if(streamData.type==="finalAnswer") {
      updatedLastMessage.done = true
      updatedLastMessage.text=streamData.value
    }
    return updatedLastMessage
  }

  const readStream = (response, updatedMessages = messages, question="Summary") => {
    const decoder = new TextDecoder();
    const reader = response.body.getReader();
    const chunks = [];
    const newMessage = { from: "chai", question, text: "...", done: false, date: new Date()};
    
    updatedMessages = [...updatedMessages, newMessage];
    setMessages(updatedMessages);
    
    const read = async (lastMessage=newMessage) => {
      const { done, value } = await reader.read();
      // all chunks have been read?
      if (done) {
        setBtnIsDisabled(false)
        return
      }
      const chunk = decoder.decode(value, { stream: true }).split("\n");
      for(let i = 0; i < chunk.length; i++) {
        if(!chunk[i].length) continue
        try {
          const data = JSON.parse(chunk[i])
          lastMessage = updateLastMessage(data, lastMessage)
          setMessages([ ...updatedMessages.slice(0,-1), lastMessage])
          chunks.push(chunk);
        } catch(e) {
          console.log("errored chunk ", chunk)
        }
      }
      return read(lastMessage); // read the next chunk
    }
    read();
  };
  const startConversation = async (advice) => {
    try {
      const res = await window.meterian.chai.startSummaryConversation(advice);
      readStream(res);
    } catch (e) {
      console.log(e);
    }
  };
  const askQuestion = async (question) => {
    try {
      if (!conversationId) return;
      setBtnIsDisabled(true);
      const updatedMessages = [
        ...messages,
        { from: "user", text: question, date: new Date() },
      ];
      setMessages(updatedMessages);
      const res = await window.meterian.chai.ask(conversationId, question);
      readStream(res, updatedMessages, question);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (startChai && !messages.length) {
      startConversation(advice);
    }
    return;
  }, [startChai]);
  return (
    <div className="chatbox-container">
      <Chatbox
        messages={messages}
        askQuestion={askQuestion}
        btnIsDisabled={btnIsDisabled}
        adviceId={advice.advice.id}
      />
    </div>
  );
}

export default Chai;
